import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tree-box" }


import { ref, onMounted } from 'vue'
import { userCustomerAreaSave, getCustomerArea } from '@/api/common'
import type { FormInstance, TreeProps } from 'ant-design-vue'
import { UserCustomerAreaSaveParams } from '@/typings/common'
import { DcMessage } from '@dc-platform/dc-components'
const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<any>({ employeeNo: '' })
const emit = __emit
const expandedKeys = ref<any>([])
const selectedKeys = ref<any>([])
const checkedKeys = ref<any>([])
const treeData = ref<TreeProps['treeData']>()
const path = ref<string>()
const toggle = (row?: UserCustomerAreaSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    console.log('editForm.value: ', editForm.value)
    const arr = [row.areaId.toString()]
    expandedKeys.value = arr
    editForm.value.selectedKeys = arr
    selectedKeys.value = arr
    path.value = row.path
  } else {
    editForm.value = {}
    expandedKeys.value = []
    editForm.value.selectedKeys = []
    selectedKeys.value = []
    path.value = ''
  }
}
const handleSelect = (selectedKeys: any, { node }: any) => {
  console.log('val: ', selectedKeys)
  path.value = node.path
}

const getTree = async () => {
  try {
    const res = await getCustomerArea({ appId: 'cos_lbu' })
    treeData.value = res.data
  } catch (error) {
    console.log('error: ', error)
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true

    try {
      if (editForm.value.selectedKeys.length > 0) {
        await userCustomerAreaSave({
          employeeNo: editForm.value.employeeNo,
          areaId: editForm.value.selectedKeys[0],
          appId: 'cos_lbu'
          // path: path.value
        })
        loading.value = false

        emit('success', editForm.value?.id ? 'edit' : 'add')
        DcMessage.success(editForm.value?.id ? '分配成功' : '新增成功')
        toggle()
      } else {
        loading.value = false

        DcMessage.error('请先选择需要分配的区域！')
      }
    } catch (error) {
      loading.value = false
    }
  })
}
onMounted(() => {
  getTree()
})
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '编辑' : '新增',
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              (!editForm.value.id)
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 0,
                    name: "employeeNo",
                    label: "员工",
                    rules: [{ required: true, message: '请输入' }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        value: editForm.value.employeeNo,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.employeeNo) = $event)),
                        placeholder: "请选择员工",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (editForm.value.id)
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 1,
                    label: "员工"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: editForm.value.userName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.userName) = $event)),
                        allowClear: "",
                        disabled: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_form_item, {
                name: "selectedKeys",
                label: "分配区域",
                rules: [{ required: true, message: '选择' }]
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_a_tree, {
                      expandedKeys: expandedKeys.value,
                      "onUpdate:expandedKeys": _cache[2] || (_cache[2] = ($event: any) => ((expandedKeys).value = $event)),
                      selectedKeys: editForm.value.selectedKeys,
                      "onUpdate:selectedKeys": _cache[3] || (_cache[3] = ($event: any) => ((editForm.value.selectedKeys) = $event)),
                      checkedKeys: checkedKeys.value,
                      "onUpdate:checkedKeys": _cache[4] || (_cache[4] = ($event: any) => ((checkedKeys).value = $event)),
                      checkable: false,
                      "tree-data": treeData.value,
                      fieldNames: { children: 'children', title: 'name', key: 'id' },
                      onSelect: handleSelect
                    }, {
                      title: _withCtx(({ name }) => [
                        _createElementVNode("span", null, _toDisplayString(name), 1)
                      ]),
                      _: 1
                    }, 8, ["expandedKeys", "selectedKeys", "checkedKeys", "tree-data"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})